<template>
  <div class="market-portal">
    <div v-if="view !== 'editor'" class="market-portal__body">
      <MarketHomePage
        v-if="view === 'market'"
        @preview="showPreview"
        @use="handleUse"
      />
      <MarketCategoryPage
        v-else-if="view === 'cat'"
        @preview="showPreview"
        @use="handleUse"
      />
      <MarketSearchPage
        v-else-if="view === 'search'"
        @preview="showPreview"
        @use="handleUse"
      />
    </div>
    <MarketActivityEditor v-else :template-id="editorTemplateId" />
    <MarketPreviewModal v-model:visible="previewVisible" :template-id="previewId" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { provideMarketPortal } from './useMarketPortal'
import { provideMarketPortalStore } from './useMarketPortalStore'
import MarketPreviewModal from './components/MarketPreviewModal.vue'
import MarketActivityEditor from './components/MarketActivityEditor.vue'
import MarketHomePage from './pages/MarketHomePage.vue'
import MarketCategoryPage from './pages/MarketCategoryPage.vue'
import MarketSearchPage from './pages/MarketSearchPage.vue'

defineOptions({ name: 'MarketPortal' })

const { view, editorTemplateId, openEditor, toast } = provideMarketPortal()
const portalStore = provideMarketPortalStore()

const previewVisible = ref(false)
const previewId = ref<number>()

const showPreview = (id: number) => {
  previewId.value = id
  previewVisible.value = true
}

const handleUse = async (id: number) => {
  if (!portalStore.isPluginReady(id)) {
    toast(portalStore.getNotReadyReason(id) || '该模板玩法尚未接入，暂不可创建活动')
    return
  }
  openEditor(id)
}

onMounted(() => {
  portalStore.loadHome()
})
</script>

<style lang="scss" scoped>
.market-portal {
  box-sizing: border-box;
  /* 抵消 StandaloneAppShell .standalone-content-inner 留白，内容贴齐系统布局 */
  margin: -20px -24px;
  width: auto;
  min-height: calc(100% + 40px);
  background: #f5f6fa;
  color: #303133;
  font-size: 14px;

  &__body {
    box-sizing: border-box;
    width: 100%;
    max-width: none;
    padding: 12px 16px 12px 12px;
  }
}
</style>
